import React,{Component} from 'react'

import {
  CardMedia,
} from 'material-ui'

const style={
  image:{
    maxHeight: '370px',
    minHeight: '244px',
    // backgroundPosition: 'center',
    // backgroundSize: 'cover',
    height: '33vw',
  }
}
export default class JobCardMedia extends Component{
  render(){
    const {job,loading} = this.props;
    return(
      <CardMedia
        style={style.image}
        title={!!loading ? 'skeletonMedia' : job.company}
        image={!!loading ? '...' : job.image && job.image.downloadURLs && job.image.downloadURLs && job.image.downloadURLs[0]}
        className={!!loading ? 'mediaSkeleton' : 'cardMediaImage'}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCardMedia.js